<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary primary-invert',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path stroke="none" d="M6.42857 20.875C6.42857 16.1872 10.2729 12.375 15 12.375C19.7271 12.375 23.5714 16.1872 23.5714 20.875H30C30 12.6597 23.2843 6 15 6C6.71571 6 4.57493e-07 12.6597 4.57493e-07 20.875L6.42857 20.875Z" />
    <path stroke="none" d="M13.333 17.8117C12.2386 18.3417 11.5512 19.5698 11.8598 20.9114C12.087 21.8991 12.8964 22.7009 13.8916 22.9263C15.245 23.233 16.4834 22.5506 17.0178 21.4653C17.8099 19.8574 18.5365 18.2182 19.4649 16.6833L21.4286 13.4375L18.1556 15.3848C16.608 16.3056 14.955 17.0255 13.333 17.8117" />
    <path fill="none" d="M13.333 17.8117C12.2386 18.3417 11.5512 19.5698 11.8598 20.9114C12.087 21.8991 12.8964 22.7009 13.8916 22.9263C15.245 23.233 16.4834 22.5506 17.0178 21.4653C17.8099 19.8574 18.5365 18.2182 19.4649 16.6833L21.4286 13.4375L18.1556 15.3848C16.608 16.3056 14.955 17.0255 13.333 17.8117" />
  </svg>
</template>
